import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import './Portfolio.css';
import Sparkles from './assets/images/Sparkles1.png';
import Footer from './components/Footer';
import SplineScene from './components/SplineScene';
import Portfolio from './components/Portfolio';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useWindowSize } from '@react-hook/window-size'; // Импортируем useWindowSize

// Importing video files
import DesktopVideoMP4 from './assets/videos/yos-gradient-map-motion-warm.mp4';
import DesktopVideoWEBM from './assets/videos/yos-gradient-map-motion-warm.webm';
import MobileVideoMP4 from './assets/videos/yos-gradient-map-motion-warm.mp4';
import MobileVideoWEBM from './assets/videos/yos-gradient-map-motion-warm.webm';

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

// Navigation component
const Navigation = ({ isHidden }) => (
  <nav className={`fixed top-0 left-0 w-full bg-white shadow-lg z-50 transition-all duration-500 ${isHidden ? 'opacity-50' : 'opacity-100'}`}>
    <div className="container mx-auto flex justify-between items-center py-4 px-6 mobile:w-fit">
      <div className="flex items-center mobile:hidden">
        <div className="flex items-center mr-8">
          <img
            className="logo-yos_top mobile:hidden"
            src="https://www.yos-studio.com/wp-content/uploads/2024/10/YOS-studio-graficzne-logo.svg"
            alt="yos studio logo"
            style={{ maxWidth: '140px' }}
          />
        </div>
      </div>
      <ul className="flex space-x-6">
        <li><a className="menu-item" href="#ads">Google & Meta Ads</a></li>
        <li><a className="menu-item" href="#web">Web Development</a></li>
      </ul>
    </div>
  </nav>
);

// Section with Text and Image Slider
const SplitSectionWithSlider = () => (
  <div className="split-section bg-gray-100 py-20">
    <div className="container mx-auto flex flex-col md:flex-row items-center">
      {/* Text part */}
      <div className="text-left w-full md:w-1/2 p-6">
        <h2 className="text-4xl font-bold mb-4">Nasze Podejście</h2>
        <p className="text-lg leading-relaxed mb-4">
          Nasze projekty to połączenie technologii i kreatywności. Oferujemy pełną obsługę digital marketingu,
          dostosowując kampanie i strategie do potrzeb każdego klienta.
        </p>
        <p className="text-lg leading-relaxed">
          Przekonaj się, jak nasze doświadczenie może pomóc w budowaniu rozpoznawalności Twojej marki
          i angażowaniu Twojej grupy docelowej.
        </p>
      </div>

      {/* Image slider */}
      <div className="slider-container w-full md:w-1/2 p-6 ">
        <Slider {...sliderSettings}>
          <div>
            <img src="https://www.yos-studio.com/wp-content/uploads/2023/07/projektowanie-grafik-do-social-media-yos-projekt-perlik-1.png" alt="Slide 1" className="rounded-md shadow-lg" />
          </div>
          <div>
            <img src="https://www.yos-studio.com/wp-content/uploads/2023/07/projektowanie-grafik-social-media-poznan-yos-future-growth.png" alt="Slide 2" className="rounded-md shadow-lg" />
          </div>
          <div>
            <img src="https://www.yos-studio.com/wp-content/uploads/2023/07/projekt-grafiki-social-media-yos-studio-poznan-jarmark-3.png" alt="Slide 3" className="rounded-md shadow-lg" />
          </div>
        </Slider>
      </div>
    </div>
  </div>
);

// Home component
const Home = () => {
  const [width, height] = useWindowSize(); // Используем хук для получения ширины и высоты окна
  const [isNavHidden, setIsNavHidden] = useState(false);
  const lastScrollY = useRef(0);
  const imageSectionRef = useRef(null);

  const handleScroll = () => {
    if (window.scrollY > lastScrollY.current) {
      setIsNavHidden(true);
    } else {
      setIsNavHidden(false);
    }
    lastScrollY.current = window.scrollY;
  
    const imageSection = imageSectionRef.current;
    if (imageSection) {
      const sectionRect = imageSection.getBoundingClientRect();
      const sectionCenter = sectionRect.top + sectionRect.height / 2;
      const windowCenter = window.innerHeight / 2;
      const offset = (windowCenter - sectionCenter) * 0.5;
  
      // Update parallax effect
      imageSection.querySelectorAll('.parallax-image').forEach((img) => {
        img.style.transform = `translateY(${offset}px) translate(-50%, -50%)`;
  
        // Calculate opacity with a larger range
        const distanceFromCenter = Math.abs(windowCenter - sectionCenter);
        const maxDistance = window.innerHeight * 1.5; // Larger distance for slower fade out
        const opacity = 1 - Math.min(distanceFromCenter / maxDistance, 1);
        img.style.opacity = opacity;
      });
    }
  };

  useEffect(() => {
    window.dispatchEvent(new Event('resize')); // Принудительно вызываем событие resize для react-slick
  }, [width, height]); // Вызываем только при изменении ширины или высоты


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    
    <div className="grid">
      <div className="grid-inner bg-neutral-300">
        <Navigation isHidden={isNavHidden} />

        {/* Video for desktop */}
        <div className="video-container  md:block">
          <video className="w-full h-auto" autoPlay loop muted playsInline>
            <source src={DesktopVideoMP4} type="video/mp4" />
            <source src={DesktopVideoWEBM} type="video/webm" />
            Your browser does not support the video tag.
          </video>
          <div className="text-over-video">
            <h1 className="text-5xl font-bold">Tworzymy cyfrowe rozwiązania dla rozwoju Twojego biznesu</h1>
            <p className="text-2xl mt-4">Kompleksowe usługi w zakresie reklamy, tworzenia stron i wsparcia marek</p>
          </div>
        </div>

        {/* New Text Section */}
        <div className="text-section text-center h-screen mobile:h-auto bg-light flex items-center justify-center flex-col p-6">
          <h2 className="text-6xl font-bold mb-7">Digital Marketing</h2>
          <p className="text-lg leading-relaxed max-w-prose mx-auto">
            Niezależnie, czy działasz w branży gastronomicznej, prowadzisz sklep odzieżowy, czy chcesz przyciągnąć nowych klientów, odpowiedź jest jedna - digital marketing.
            Kluczem do sukcesu jest zbudowanie silnej pozycji w świecie online, który niestety nie wybacza, ale my tak - po to jesteśmy!
          </p>
          <p className="text-lg leading-relaxed mt-7 max-w-prose mx-auto">
            Digital marketing to, w skrócie, promocja usług, firm i marek oraz angażowanie odbiorców wykorzystując wszystkie możliwe kanały cyfrowe:
            media społecznościowe, wyszukiwarki itp. 
            Chciałbyś zainteresować swoimi treściami szersze grono potencjalnych klientów i jednocześnie budować autentyczną i odnoszącą sukcesy markę nie wpędzając się w zbędne koszta?
          </p>
          <p className="text-lg leading-relaxed mt-7 max-w-prose mx-auto">
            Zajmujemy się kompleksową obsługą kanałów społecznościowych marek, opracowujemy i wdrażamy kampanie w Google ads i Facebook Ads (META) oraz projektujemy niezbędne grafiki i kreacje, które uatrakcyjnią Twój profil – czyli wszystko to, co niezbędne do budowy świadomości i pozyskania odbiorców Twojej marki.
            Zapoznaj się z naszą ofertą i umów się na konsultacje!
          </p>
        </div>

        {/* ADS Section */}
        <div id="ads" className="bg-gradient">
          <div className="m-auto container">
            <div className="row first-row">
              <div className="row-inner w-full m-2.5">
                <div className="column-wrap">
                  <div className="col stack">
                    <div className="stack-element">
                      <div className="pt-8">
                        <p className="header">Google & Meta Ads</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row second-row">
              <div className="row-inner w-full">
                <div className="column-wrap mobile:flex-col">
                  <Card
                    title="STARTER"
                    price="800 zł dla 2000 zł"
                    items={['Dedykowany Opiekun', 'Dostęp do wszystkich rodzajów kampanii reklamowych', 'Kampanie remarketingowe', 'Strategia dopasowana do potrzeb i możliwości klienta', 'Zarządzanie budżetem marketingowym', 'Testy A/B', 'Implementacja pliku produktowego', 'Wsparcie przy implementacji Google Tag, czy Meta Pixel', 'Wykorzystanie algorytmów AI oraz machine learning’u']}
                  />
                  <Card
                    title="STANDARD"
                    price="1500 zł dla 6000 zł"
                    items={['Dedykowany Opiekun', 'Dostęp do wszystkich rodzajów kampanii reklamowych', 'Kampanie remarketingowe', 'Strategia dopasowana do potrzeb i możliwości klienta', 'Zarządzanie budżetem marketingowym', 'Testy A/B', 'Implementacja pliku produktowego', 'Wsparcie przy implementacji Google Tag, czy Meta Pixel', 'Wykorzystanie algorytmów AI oraz machine learning’u', 'Pakiet grafik ADS (3 formaty)']}
                  />
                  <Card
                    title="PREMIUM"
                    price="3000 zł dla 20 000 zł"
                    items={['Dedykowany Opiekun', 'Dostęp do wszystkich rodzajów kampanii reklamowych', 'Kampanie remarketingowe', 'Strategia dopasowana do potrzeb i możliwości klienta', 'Zarządzanie budżetem marketingowym', 'Testy A/B', 'Implementacja pliku produktowego', 'Wsparcie przy implementacji Google Tag, czy Meta Pixel', 'Wykorzystanie algorytmów AI oraz machine learning’u', 'Implementacja zdarzeń tagu śledzącego', '2 pakiety grafik ADS (3 formaty)']}
                  />
                  <Card
                    title="INDIVIDUAL"
                    price="Od 20 000 zł"
                    items={['W celu otrzymania spersonalizowanej oferty umów się na konsultację']}
                    imgAlt="Stars"
                    imgSrc={Sparkles}
                    isCentered={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Split Section with Slider */}
        <SplitSectionWithSlider />

        {/* Parallax Section */}
        <div ref={imageSectionRef} className="container m-auto text-image-section relative flex flex-col md:flex-row items-center py-20 h-1/5 mobile:h-auto">
          <div className="w-full md:w-1/2 px-6 ml-auto">
            <h2 className="text-4xl font-bold text-center my-4">Kreatywność i technologia w każdym projekcie</h2>
            <p className="text-lg mt-6 text-center">
              Od tworzenia treści po analizę wyników – nasze podejście łączy kreatywne rozwiązania ze sprawdzonymi narzędziami.
            </p>
          </div>
          <div className="w-full md:w-1/2 px-6 mt-8 md:mt-0 flex relative">
            <img className="parallax-image" src="https://www.yos-studio.com/wp-content/uploads/2024/10/YOS-studio-graficzne-logo.svg" alt="yos studio logo" />
          </div>
        </div>

        {/* Web Development Section */}
        <div id="web" className="animated-gradient bg-red-400 relative">
          <div className="m-auto container pb-10">
            <div className="row first-row">
              <div className="row-inner w-full m-2.5">
                <div className="column-wrap">
                  <div className="col stack">
                    <div className="stack-element">
                      <div className="pt-8">
                        <p className="header">Web Development</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row second-row">
              <div className="row-inner w-full">
                <div className="column-wrap mobile:flex-col">
                  <Card
                    title="Strona wizytówka"
                    price="Od 3000 zł"
                    items={['Podstawowa i najtańsza wersja strony WWW', 'System dedykowany lub działający na popularnym i praktycznym systemie CMS WordPress', 'Ilość podstron: 1, strona jednostronicowa. Wszystkie informacje dostępne są na stronie głównej.', 'Domena i obsługa 1 konta pocztowego przez pierwszy rok.', 'Dostęp do biblioteki zdjęć.', 'Pomoc i konsultacje w trakcie całego procesu tworzenia witryny.', 'Po stworzeniu strony, całość umieszczona на serwerze.', 'Możliwość późniejszej rozbudowy strony we własnym zakresie.']}
                  />
                  <Card
                    title="Strona internetowa"
                    price="Od 5000 zł"
                    items={['Strona działająca na popularnym i praktycznym systemie CMS WordPress', 'Liczba podstron до 10', 'Aktualności, galerie, formularze kontaktowe, zgłoszeniowe.', 'Strona dynamiczna, dopasowana do urządzeń: telefony komórkowe, laptopy, tablety, komputery stacjonarne.', 'Domena, usługi hostingowe i obsługa poczty, przez pierwszy rok użytkowania.', 'Możliwość самodzielnej edycji strony. Не trzeba znać języków programowania.', 'Całościowy portal umieszczony на serwerze.']}
                  />
                  <Card
                    title="Sklep internetowy"
                    price="Od 9000 zł"
                    items={['Sklep działający на platformach (PrestaShop, WooCommerce).', 'Sklep działający на systemie WooCommerce или PrestaShop.', 'Podstawowa cena obejmuje konfigurację systemu płatności, wysyłki, koszyk, podstrony produktów, obsługa zamówień.', 'Cena obejmuje domenę sklepu oraz maksymalnie 3 kontа pocztowe.', 'Inne elementy ustalane są indywidualnie.']}
                  />
                  <Card
                    title="INDIVIDUAL"
                    price="od 10 000 zł"
                    items={['W celu otrzymania spersonalizowanej oferty umów się на konsultację']}
                    imgAlt="Stars"
                    imgSrc={Sparkles}
                    isCentered={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

const App = () => (
  <Router>
    <div className="grid">
      <div className="grid-inner bg-neutral-300">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
        </Routes>
      </div>
    </div>
  </Router>
);

const Card = ({ title, price, items, imgSrc, imgAlt, isCentered }) => {
  const [firstPrice, secondPrice] = price.includes('dla') ? price.split(' dla ') : [price, null];

  return (
    <div className="digital-option">
      <h1>{title}</h1>
      <hr />
      <ul className={`items-list ${isCentered ? 'centered-text-last' : ''}`}>
        {items.map((item, index) => (
          <li key={index}>
            {!isCentered && <span className="leading-none">✔</span>} <div className="lh-1_3">{item}</div>
          </li>
        ))}
      </ul>
      <hr className="mt-auto" />
      <p className="price">
        <span className="underline-price">{firstPrice}</span>
        {secondPrice && ` dla ${secondPrice}`}
      </p>
      <a href="#" className="digital-btn">wybieram</a>
      {imgSrc && <img className="sparkle-img" src={imgSrc} alt={imgAlt} />}
    </div>
  );
};

export default App;
